export default __webpack_public_path__ + "static/media/webinar3.3ca48baf.jpeg";